module.exports = __webpack_public_path__ + "static/media/Raisa.d142f1fb.jpg";